import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import ComingSoonModal from "../components/coming_soon_modal.jsx";
import { commonConfigs, urls } from "../../../config.js";
import PricingPlanTab from "./components/pricing_plan_tab.jsx";
import { pricingPlanCurrentTabContext } from "./context/pricing_plan_context.jsx";
import CertificationUatPlan from "./components/certification_uat_plan.jsx";
import CertificationGoLivePlan from "./components/certification_go_live_plan.jsx";
import ProductionPlan from "./components/production_plan.jsx";
import StagingCatalogueCard, { mockData } from "./components/staging_catalogue_card.jsx";
import TechSupportPlan from "./components/tech_support_plan.jsx";

const PricingPlanLayout = () => {
  const [load, setLoad] = useState(false);
  const [isOpen, setOpen] = useState(false);
  const [comingSoonDate, setComingSoonDate] = useState(null);
  const [isMobile, setIsMobile] = useState(false);
  const { currentTab } = useContext(pricingPlanCurrentTabContext);

  // Mobile detection
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const handleComingSoonClick = (date) => {
    setComingSoonDate(date);
    setOpen(true);
  };

  if (!load) {
    return (
      <div>
        {/* Mobile Header - Only shown on mobile */}
        {isMobile && (
          <div className="text-center p-4 mb-4">
            <h1 className="text-2xl font-bold text-gray-900 mb-2">
              Pricing Plans
            </h1>
            <p className="text-gray-600 text-sm">
              Choose the perfect plan for your needs
            </p>
          </div>
        )}

        <div className={`${isMobile ? 'px-4' : 'mt-4 desktop:space-x-6 mobile:pt-2 mobile:pb-4 mobile:space-x-2'}`}>
          <div style={isMobile ? {} : { display: "inline-flex", float: "right" }}>
            <Link to="/invoices">
              <button
                onClick={() => handleComingSoonClick()}
                type="button"
                className={`hover:bg-blue-500 text-blue-500 hover:text-white outline outline-blue-500 font-bold py-2 px-12 rounded-full ${
                  isMobile ? 'w-full mb-4' : 'mr-6'
                }`}
                style={isMobile ? {} : { float: "right" }}
              >
                Invoices
              </button>
            </Link>
          </div>

          {/* calling the Card component */}
          <div className={isMobile ? '' : 'mt-4'}>
            <div
              className={`flex-1 min-w-0 ${isMobile ? 'mb-4' : 'mobile:pt-4 mobile: ml-2'}`}
              style={isMobile ? {} : { marginBottom: "-20px" }}
            >
              <PricingPlanTab />
            </div>

            {currentTab.name == "Staging" && (
              <div className=" grid gap-4 mt-8 grid-cols-1  sm:grid-cols-2 lg:grid-cols-3  xl:grid-cols-4 justify-center mr-4 ">
                {mockData.map((plan) => (
                  <div key={plan.project_api_plan_id} className={isMobile ? "w-full flex justify-center" : ""}>
                    <StagingCatalogueCard
                      planName={plan.project_name}
                      price={plan.fixed_rate.toFixed(2)}
                      billingCycle="/month"
                      features={plan.features}
                      isMobile={isMobile}
                    />
                  </div>
                ))}
              </div>
            )}

            {currentTab.name == "Production" && (
              <>
                <div className={isMobile ? "w-full" : "mr-5"}>
                  <ProductionPlan isMobile={isMobile} />
                </div>
              </>
            )}

            {currentTab.name == "Tech Support" && (
              <>
                <div className={isMobile ? "w-full" : "mr-5"}>
                  <TechSupportPlan isMobile={isMobile} />
                </div>
              </>
            )}

            {currentTab.name == "Certification (UAT)" && (
              <>
                <CertificationUatPlan currentTab={currentTab} isMobile={isMobile} />
              </>
            )}

            {currentTab.name == "Certification (Go Live)" && (
              <>
                <CertificationGoLivePlan currentTab={currentTab} isMobile={isMobile} />
              </>
            )}
          </div>
        </div>

        {/* Mobile spacing */}
        {isMobile && <div className="h-8"></div>}

        {isOpen && (
          <ComingSoonModal
            setOpenModal={setOpen}
            comingSoonDate={comingSoonDate}
          />
        )}
      </div>
    );
  }

  // Loading state
  return (
    <div className={`w-full min-h-screen bg-gray-100 flex items-center justify-center ${
      isMobile ? 'p-4' : 'p-6'
    }`}>
      <div className="text-center">
        <div className={`animate-spin rounded-full border-4 border-blue-200 border-t-blue-600 mx-auto mb-4 ${
          isMobile ? 'h-12 w-12' : 'h-16 w-16'
        }`}></div>
        <h3 className={`font-medium text-gray-900 ${isMobile ? 'text-lg' : 'text-xl'}`}>
          Loading Pricing Plans
        </h3>
        <p className={`text-gray-600 ${isMobile ? 'text-sm' : 'text-base'}`}>
          Please wait while we fetch the pricing information...
        </p>
      </div>
    </div>
  );
};

export default PricingPlanLayout;